import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiRocketLaunch, mdiSchool, mdiDanceBallroom, mdiTicket, mdiAccountGroup, mdiEmailOutline, mdiHelpCircleOutline, mdiCurrencyUsd } from '@mdi/js';
import { useAuth } from '../contexts/AuthContext';
import AppHeader from '../components/AppHeader';
import '../pages/Common.css';
import '../pages/Dashboard.css';
import '../pages/header.css';
import './HelpPage.css';
/**
 * HelpPage - Help hub navigation page
 * Portal type: Portal Landing (.portal-header-card)
 */
const HelpPage = () => {
    const navigate = useNavigate();
    const { checkPermission } = useAuth();
    const backPath = checkPermission('viewDashboard') ? '/dashboard' : '/classes';
    const backLabel = checkPermission('viewDashboard') ? '← Dashboard' : '← Classes';

    const helpCards = [
        { path: '/help/getting-started', icon: mdiRocketLaunch, title: 'Getting Started', description: 'Set up your studio account and get your first class running' },
        { path: '/help/classes', icon: mdiSchool, title: 'Classes Guide', description: 'Terms, enrolments, check-in and student management' },
        { path: '/help/private-lessons', icon: mdiDanceBallroom, title: 'Private Lessons', description: 'Availability, booking management and student communication' },
        { path: '/help/ticketing', icon: mdiTicket, title: 'Ticketing Guide', description: 'Create events, manage ticket sales and QR check-in' },
        { path: '/help/students', icon: mdiAccountGroup, title: 'Managing Students', description: 'Enrolments, payments, re-enrolments and student records' },
        { path: '/help/finances', icon: mdiCurrencyUsd, title: 'Finances & Payments', description: 'Stripe Connect setup, payouts, refunds and Financial Dashboard' },
        { path: '/help/contact', icon: mdiEmailOutline, title: 'Contact Support', description: 'Get help from our team for any issue' },
        { path: '/faq', icon: mdiHelpCircleOutline, title: 'FAQ', description: 'Answers to common questions' },
    ];

    return (
        <div className="dashboard-container org-console">
            <AppHeader activeItem="help" />

            <div className="dashboard-main">
                <div className="dashboard-content-wrapper help-page" style={{ maxWidth: '900px' }}>
                    {/* Portal Header Card */}
                    <div className="portal-header-card">
                        <div className="portal-header-title-row">
                            <button
                                onClick={() => navigate(backPath)}
                                className="back-nav-btn">
                                {backLabel}
                            </button>
                            <h1 className="portal-header-title">Help &amp; Support</h1>
                        </div>
                        <p className="portal-header-subtitle">
                            Find guides, answers and support for every part of Dance Localé.
                        </p>
                    </div>

                    {/* Navigation Cards Grid */}
                    <div className="help-cards-grid">
                        {helpCards.map((card) => (
                            <Link
                                key={card.path}
                                to={card.path}
                                className="content-card nav-card help-page-nav-card">
                                <div className="help-page-card-header">
                                    <Icon path={card.icon} size={1.4} color="var(--dl-color-purple-default)" />
                                    <h3 className="help-page-card-title">{card.title}</h3>
                                </div>
                                <p className="help-page-card-description">{card.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpPage;
